import { APP_ROUTES } from '@cpd-app/core-module/constants/routes';

export interface FooterViewer {
  isPhone: boolean;
  isAdmin: boolean;
  isCounselor: boolean;
}

/**
 * MOBILE.1 D10. Which footer links to show.
 *
 * On a phone, Administration is shown only to an administrator and Analytics
 * only to a counselor or above, matching the route guards, which send anyone
 * else to an error page. At laptop width the list is returned as it is, so
 * the desktop footer does not change.
 */
export function footerLinksFor<T extends { path: string }>(
  links: T[],
  viewer: FooterViewer
): T[] {
  if (!viewer.isPhone) {
    return links;
  }

  return links.filter((link) => {
    if (link.path === APP_ROUTES.Manager.Base) {
      return viewer.isAdmin;
    }

    if (link.path === APP_ROUTES.Analytics) {
      return viewer.isCounselor;
    }

    return true;
  });
}
